<template>
  <AllEvents />
</template>

<script>
import AllEvents from "@/components/organisms/AllEvents";

export default {
  components: { AllEvents },
};
</script>